export const SET_EXPERIENCES_WITH_PEOPLE_WAITING = "SET_EXPERIENCES_WITH_PEOPLE_WAITING";

export function setExperiencesWithPeopleWaiting(data) {
  return {
    type: SET_EXPERIENCES_WITH_PEOPLE_WAITING,
    data
  };
}